import { render, staticRenderFns } from "./ExamRadioBox.vue?vue&type=template&id=3365257a&"
import script from "./ExamRadioBox.vue?vue&type=script&lang=js&"
export * from "./ExamRadioBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3365257a')) {
      api.createRecord('3365257a', component.options)
    } else {
      api.reload('3365257a', component.options)
    }
    module.hot.accept("./ExamRadioBox.vue?vue&type=template&id=3365257a&", function () {
      api.rerender('3365257a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/ExamRadioBox.vue"
export default component.exports